/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from '../JointlyOwnedVehicleInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { changeObjectPropertyAction, listDeleteAction } from 'redux/actions'

const JointlyOwnedVehicleListTable = ({ t, i18n, setIsError, reviewConfirmation = false, isSummary = false }) => {
    let history = useHistory()
    const dispatch = useDispatch();
    const vehicles = useSelector((state) => state.app.jointlyOwnedVehicleInformation.vehicles)
    useEffect(() => {
        try {
            if (!isSummary && vehicles.length === 0) {
                dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'editMasterNumber', ''));
                history.push(`/${i18n.language}${t('routes.jointly_owned_vehicle_info')}`)
            }
            // vehicle.map((householdMember) => {
            //   if (!isValidPermit(householdMember)) {
            //     // TODO: HOOKUP
            //     // dispatch(listDeleteAction(householdMember.plateNumber))
            //   }
            // })
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [vehicles, history, i18n.language, isSummary, setIsError, t, dispatch])

    return (
        <div className="row">
            <div className="col-xs-12 col-lg-8">
                <div className={styles['overflow_mobile']}>
                    {/* <table className={['table', styles['border_none']].join(' ')} style={{ marginBottom: '0px' }}> */}
                    {vehicles.map((vehicle, i) => {
                        return <VehicleRow key={i} isLast={i === vehicles.length - 1} vehicle={vehicle} t={t} i18n={i18n} setIsError={setIsError} reviewConfirmation={reviewConfirmation} isSummary={isSummary} />
                    })}
                    {/* </table> */}
                </div>
            </div>
        </div>
    )
}

const VehicleRow = ({ vehicle, i18n, t, setIsError, reviewConfirmation, isSummary, isLast }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    // const { name, jointMasterNumber } = useSelector((state) => state.app.jointlyOwnedVehicleInformation)
    // const permitEl = useRef(null)

    const editVehicleOnClick = () => {
        try {

            const { jointMasterNumber } = vehicle;
            dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'editMasterNumber', jointMasterNumber));
            dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'name', vehicle.name));
            dispatch(changeObjectPropertyAction('jointlyOwnedVehicleInformation', 'jointMasterNumber', vehicle.jointMasterNumber));

            // if (reviewConfirmation) {
            //     // TODO: HOOKUP
            //     // dispatch(editFromConfirmationAction(true));
            // }
            history.push(`/${i18n.language}${t('routes.jointly_owned_vehicle_info')}?isSummary=${isSummary}`)
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    const removeVehicleOnClick = () => {
        try {
            const { jointMasterNumber } = vehicle
            dispatch(listDeleteAction("jointlyOwnedVehicleInformation", jointMasterNumber))
            if (reviewConfirmation) {
                // history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    // const dashIfNull = (data) => {
    //     return data ? data : '-'
    // }

    const popUpBox = () => {
        let confirmText = window.confirm(`${t('are_you_sure')}`)
        if (confirmText == true) {
            // console.log('hit true')
            removeVehicleOnClick();
        }
        // else {
        //   console.log("do nothing")
        // }
    }

    return (

        <div className="row">
            <div className="col-xs-12 col-lg-12">
                <div className="col-xs-12">
                    <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
                        <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "center" }}>
                            <div className="col-xs-6">
                                <h3>{t('review_summary.jointly_owned_vehicle')}</h3>
                                <br></br>

                            </div>
                            <div className="col-xs-6">

                                <a href="#" className={[styles['edit_button']].join(' ')}
                                    onClick={editVehicleOnClick}
                                    value={t('jointly_owned_vehicle_summary.edit')} name={t('jointly_owned_vehicle_summary.edit')}>
                                    {t('jointly_owned_vehicle_summary.edit')}
                                </a>
                                {!isSummary && (
                                    <a
                                        href={reviewConfirmation ? `/${i18n.language}${t('routes.review_confirmation')}` : `/${i18n.language}${t('routes.jointly_owned_summary')}`}
                                        onClick={popUpBox}
                                        value={' ' + t('jointly_owned_vehicle_summary.remove')}
                                        name={' ' + t('jointly_owned_vehicle_summary.remove')}
                                    >
                                        {' ' + t('jointly_owned_vehicle_summary.remove')}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('jointly_owned_vehicle_summary.name')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{vehicle.name}</div>
                    </div>
                    <hr />

                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('jointly_owned_vehicle_summary.joint_master_number')}</strong></div>
                        <div className="col-xs-6">{vehicle.jointMasterNumber.toUpperCase()}</div>
                    </div>

                    <hr />

                </div>
            </div>
        </div>

    )
}

export default withTranslation('common')(JointlyOwnedVehicleListTable)
